import { useMembersListTeamListGetQuery } from '@shared/api';

interface UseGetTeamMembersProps {
  organizationId?: number;
  search?: string;
  skip?: boolean;
}

export const useGetTeamMembers = ({ organizationId, skip }: UseGetTeamMembersProps) => {
  const queryArgs = {
    organizationId: Number(organizationId),
  };

  const { data, isLoading, isFetching, isError } = useMembersListTeamListGetQuery(queryArgs, {
    skip,
  });

  const isEmpty = !data?.length || isError;

  return {
    teamMembers: data,
    isEmpty,
    isLoading,
    isFetching,
  };
};
